// Sidebar del rol Supervisor.

import { useCorreccionesParo } from '../../features/supervisor/correccionesParoQueries';
import { useParosPendientesCausal, useRegistrosPendientesCompletar } from '../../lib/api/ingesta';
import { useSupervisorPendientes } from '../../lib/api/queries';
import { Sidebar, SidebarGroup, SidebarItem } from './SidebarNav';

export function SupervisorSidebar() {
  // Correcciones de paro propuestas por mantenimiento sin resolver → badge en
  // "Incidencias" (la bandeja vive como pestaña de esa pantalla). Misma query
  // que la pestaña y el aviso de S1 — se cachea y pollea cada 30s.
  const { data: correcciones } = useCorreccionesParo('propuesta');
  const propuestas = correcciones?.conteos.propuestas ?? 0;
  // Bloques sin validar HOY (día operativo) → badge en "Pendientes".
  // Misma query que la pantalla S10 sin filtros — se comparte caché.
  const { data: pendientes } = useSupervisorPendientes({});
  const pendHoy = pendientes?.resumen.bloques ?? 0;
  // Integración con máquina: paros sin causal y horas por completar de sus
  // plantas (misma caché y poll de 30 s que la pantalla S11). El item solo
  // aparece con algo pendiente: sin líneas de máquina el sidebar no cambia.
  // Rótulos cortos ("Pendientes", "Datos de máquina"): los largos se truncaban
  // en el ancho del sidebar; el conteo del badge lleva el detalle.
  const { data: parosMaquina } = useParosPendientesCausal();
  const { data: horasMaquina } = useRegistrosPendientesCompletar();
  const parosSinCausal = parosMaquina?.length ?? 0;
  const pendMaquina = parosSinCausal + (horasMaquina?.length ?? 0);

  return (
    <Sidebar>
      <SidebarGroup label="Turno">
        <SidebarItem to="/supervisor" end icon="gauge">
          Dashboard
        </SidebarItem>
        <SidebarItem to="/supervisor/resumen" icon="clock">
          Resumen hora a hora
        </SidebarItem>
        <SidebarItem
          to="/supervisor/pendientes"
          icon="check"
          badge={pendHoy > 0 ? String(pendHoy) : undefined}
          badgeTone="warn"
        >
          Pendientes
        </SidebarItem>
        {pendMaquina > 0 ? (
          <SidebarItem
            to="/supervisor/datos-maquina"
            icon="plug"
            badge={String(parosSinCausal > 0 ? parosSinCausal : pendMaquina)}
            badgeTone="warn"
          >
            Datos de máquina
          </SidebarItem>
        ) : null}
        <SidebarItem to="/supervisor/tiendas" icon="storefront">
          Corridas de tiendas
        </SidebarItem>
        <SidebarItem
          to="/supervisor/incidencias"
          icon="alert"
          badge={propuestas > 0 ? String(propuestas) : undefined}
          badgeTone="warn"
        >
          Incidencias
        </SidebarItem>
        <SidebarItem to="/supervisor/historico" icon="chart-bar">
          Histórico
        </SidebarItem>
        <SidebarItem to="/supervisor/mis-acciones" icon="shield">
          Mis acciones
        </SidebarItem>
      </SidebarGroup>
    </Sidebar>
  );
}
